
import { useState } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import { googleAuthService } from "@/auth/google";
import { CheckCircle } from "lucide-react";
import { GoogleSignInButton } from "@/components/GoogleSignInButton";

const IntegrationsTab = () => {
  const [isConnecting, setIsConnecting] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const { toast } = useToast();

  const handleConnectToGoogle = async () => {
    setIsConnecting(true);
    
    try {
      // Ensure Google is initialized
      await googleAuthService.initialize();
      
      // Request Gmail permissions
      googleAuthService.requestGmailPermissions(
        (accessToken) => {
          // Success callback
          console.log('Gmail access token received:', accessToken);
          
          // Store the token (in a real app, this would be sent to backend)
          localStorage.setItem('gmail_access_token', accessToken);
          
          setIsConnected(true);
          setIsConnecting(false);
          
          toast({
            title: "Gmail Connected Successfully",
            description: "You can now access your email metadata for organization.",
          });
        },
        (error) => {
          // Error callback
          console.error('Gmail connection failed:', error);
          setIsConnecting(false);
          
          toast({
            title: "Connection Failed",
            description: "Failed to connect to Gmail. Please try again.",
            variant: "destructive",
          });
        }
      );
    } catch (error) {
      console.error('Failed to initialize Google services:', error);
      setIsConnecting(false);
      
      toast({
        title: "Initialization Error",
        description: "Failed to initialize Google services. Please refresh and try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Card className="bg-white shadow-sm border border-gray-200">
      <CardHeader className="pb-4 px-4 lg:px-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Connect to Mayl AI</h3>
          <p className="text-sm text-gray-600 mt-1">
            Connect your email to start experiencing the power of Mayl AI
          </p>
        </div>
      </CardHeader>
      <CardContent className="px-4 lg:px-6">
        <div className="flex flex-col py-4">
          {isConnected ? (
            <div className="flex flex-col items-center space-y-2">
              <div className="flex items-center space-x-2 text-green-600">
                <CheckCircle className="w-5 h-5" />
                <span className="font-medium">Gmail Connected</span>
              </div>
              <p className="text-xs text-gray-500 text-center max-w-sm">
                Your Gmail account is now connected and ready for inbox organization.
              </p>
            </div>
          ) : (
            <>
              <div onClick={handleConnectToGoogle} className={`flex justify-start mb-3 ${isConnecting ? 'pointer-events-none opacity-50' : ''}`}>
                <GoogleSignInButton customText="Connect Gmail" />
              </div>
              <p className="text-xs text-gray-500 max-w-sm">
                Securely connect through Google's official authentication. This connection is established directly with Google following their security protocols and privacy guidelines.
              </p>
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default IntegrationsTab;
